import axios from 'axios'

export function parseChatError(err) {
  if (axios.isCancel(err) || err?.code === 'ERR_CANCELED') {
    return { ok: false, code: 'ABORTED', message: 'Request was cancelled.' }
  }
  if (!axios.isAxiosError(err)) {
    return { ok: false, code: 'UNKNOWN', message: err instanceof Error ? err.message : 'Chat failed.' }
  }
  if (!err.response) {
    return { ok: false, code: 'NETWORK', message: `Could not reach the chat API (${err.message}).` }
  }
  const body = err.response.data
  const hint = body?.message || body?.error || body?.detail || ''
  return {
    ok: false,
    code: 'HTTP',
    message: [`Chat request failed (HTTP ${err.response.status}).`, hint && `Server: ${hint}`]
      .filter(Boolean)
      .join(' '),
  }
}
